import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import type { UpdateVenue } from "~pages/Venues/types/upsertVenue.ts";
import type { VenueResponse } from "~types/venue.ts";

export const useUpdateVenue = () => {
  const { sport, organizationId } = useParams();
  const queryClient = useQueryClient();
  const request = useApi();

  return useMutation<VenueResponse, Error, UpdateVenue>({
    mutationFn: async ({ venueId, ...body }) =>
      await request<VenueResponse>(`${sport}/o/${organizationId}/venues/${venueId}`, {
        method: "PUT",
        body,
      }),
    onSuccess: async (_response, { venueId }) => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ["venues", sport, organizationId] }),
        queryClient.invalidateQueries({ queryKey: ["venues", sport, organizationId, venueId] }),
        queryClient.invalidateQueries({ queryKey: ["seasonVenues", sport, organizationId] }),
      ]);
    },
  });
};
